import { useLocation } from 'react-router-dom';
import { getValueFromUrl } from './helpers';

export const useLocationSearch = () => {
  const location = useLocation();
  return getValueFromUrl(location?.search, 'search');
};
